export default __webpack_public_path__ + "static/media/ACM-logo.c4bddf0c.svg";